import React, { useMemo } from "react";
import * as Constants from "../api/constants";

const imageContext = require.context(
  "../images",
  true,
  /\.(png|jpe?g|gif|svg|webp|avif)$/i
);

/**
 * Resolve bundled image path from `src/images/` (any subfolder). Returns URL string or null.
 */
export function resolveBundledImageUrl(imageName) {
  if (imageName == null || String(imageName).trim() === "") return null;
  const clean = String(imageName).trim().replace(/^\.\//, "").replace(/\\/g, "/");
  if (/^https?:\/\//i.test(clean)) return clean;

  if (clean.startsWith("/media/")) {
    const base = String(Constants.HOST || "").replace(/\/+$/, "");
    return `${base}${clean.startsWith("/") ? clean : `/${clean}`}`;
  }

  const keys = imageContext.keys();
  const norm = (s) => s.replace(/\\/g, "/").toLowerCase();
  const lowerClean = norm(clean);

  let hit = keys.find((k) => {
    const nk = norm(k);
    return (
      nk === `./${lowerClean}` ||
      nk.endsWith(`/${lowerClean}`) ||
      nk.endsWith(lowerClean)
    );
  });
  if (!hit) return null;
  try {
    const mod = imageContext(hit);
    if (mod && typeof mod === "object" && mod.default != null) return mod.default;
    return mod;
  } catch {
    return null;
  }
}

export default function AddonItemImage({ imageName, className }) {
  const src = useMemo(() => resolveBundledImageUrl(imageName), [imageName]);

  if (!src) {
    return (
      <div
        className={`grid h-full min-h-[4rem] w-full place-items-center rounded-lg bg-gradient-to-br from-slate-100 to-slate-200/80 text-xs font-bold text-slate-500 ${className || ""}`}
      >
        Image
      </div>
    );
  }

  return <img src={src} alt="" className={className} />;
}
